let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("clO1C")).then(() => parcelRequire('1JqFz'));